import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { FaRegBell } from "react-icons/fa";
import { client } from "../../index";
import { GET_ACTIVE_BELL_NOTIFICATIONS } from "./Bell.query";

const Bell = () => {
  const { data, refetch } = useQuery(GET_ACTIVE_BELL_NOTIFICATIONS, client);
  const location = window.location.href;
  useEffect(() => {
    if (location.includes("notification-center")) {
      refetch();
    }
  }, [location, refetch]);

  let numNotifications = data?.getNotificationsBellCount?.Active || 0;
  let showBadge = !!numNotifications;
  if (numNotifications > 99) {
    numNotifications = "99+";
  }

  return (
    <div className="usa-header-text notification-bell">
      <Link
        to={`/dashboard/notification-center`}
        title="Notification Center"
        aria-label="Notification Center"
      >
        <FaRegBell />
        {showBadge && <span>{numNotifications}</span>}
      </Link>
    </div>
  );
};
export default Bell;
